import axios from "axios";
import { Constants } from "./../config/constants";

const API_KEY = Constants.xApiKey;
const CLIENT_ID = Constants.clientId;
const API_DOMAIN = Constants.msilLoginUrl;
const LOGIN_REDIRECT_URL = Constants.loginRedirectUrl;

if (!API_DOMAIN) {
  console.error('❌ CRITICAL ERROR: API_DOMAIN is not configured.');
}

const api = axios.create({
  baseURL: API_DOMAIN,
  headers: {
    'Content-Type': 'application/json',
    'x-api-key': API_KEY
  }
});

/**
 * Create API request configuration
 * @param {string} endpoint - The API endpoint path
 * @param {object} data - Request payload
 * @returns {object} Axios config object
 */
const createConfig = (endpoint, data) => {
  return {
    method: 'post',
    maxBodyLength: Infinity,
    url: endpoint,
    data: JSON.stringify(data)
  };
};

/**
 * Make API request and return data
 * @param {object} config - Axios config
 * @param {string} errorMessage - Error message for exception
 * @returns {Promise} Response data
 */
const makeRequest = async (config, errorMessage) => {
  try {
    const response = await api.request(config);
    
    return response?.data?.data;
  } catch (error) {
    
    throw new Error(`[${errorMessage}: ${error.message}`);
  }
};

export const getADFSLoginUrl = async () => {
  try {
    const payload = {
      redirectUrl: LOGIN_REDIRECT_URL,
      clientId: CLIENT_ID
    };

    const config = createConfig('login-with-federation', payload);
    
    const result = await makeRequest(config, 'Unable to initiate login');
    return result;
  } catch (error) {
    console.error('[LOGIN] FAILED:', error.message);
    throw error;
  }
};

export const getADFSLogoutUrl = async () => {
  try {
    const payload = {
      redirectUrl: LOGIN_REDIRECT_URL,
      clientId: CLIENT_ID
    };

    const config = createConfig('logout-with-federation', payload);
    
    const result = await makeRequest(config, 'Unable to initiate logout');
    return result;
  } catch (error) {
    console.error('[LOGOUT] FAILED:', error.message);
    throw error;
  }
};

export const getADFSTokenUrl = async (code) => {
  
  if (!code) {
    console.error('[TOKEN] FAILED: Authorization code is required but was not provided');
    throw new Error('Authorization code is required');
  }
  
  try {
    
    const payload = {
      code,
      redirectUrl: LOGIN_REDIRECT_URL,
      clientId: CLIENT_ID
    };

    const config = createConfig('get-token', payload);
    const result = await makeRequest(config, 'Unable to retrieve token');
    
    return result;
  } catch (error) {
    console.error('[TOKEN] FAILED:', error.message);
    throw error;
  }
};

